import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ai-message" }
const _hoisted_2 = {
  class: "left-panel",
  relative: ""
}
const _hoisted_3 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["chat", {error: $props.error}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Icon, {
          class: "icon",
          height: "2rem",
          width: "2rem",
          icon: "stars-03"
        }),
        _renderSlot(_ctx.$slots, "additional-icon", {}, undefined, true)
      ]),
      _createElementVNode("div", {
        class: "text",
        innerHTML: $options.html
      }, null, 8 /* PROPS */, _hoisted_3)
    ], 2 /* CLASS */)
  ]))
}